import LoadingImage from './LoadingImage';

export default LoadingImage;
